//////////////////////////////

module.exports = (type) => {
    var schema = {
        rwqueue_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'rwqueues',
                key         : 'id',
                constraints : true,
                store_name  : 'rwqueue',
            }
        },
        rwreport_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'rwreports',
                key         : 'id',
                constraints : true,
                store_name  : 'rwreport',
            }
        },
        rwcompany_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'rwcompanies',
                key         : 'id',
                constraints : true,
                store_name  : 'rwcompany',
            }
        },
        date: {
            type: type.DATEONLY,
            allowNull: false,
        },
        config: {
            type: type.JSON,
            allowNull: false,
            defaultValue: {},
        },
        state: {
            type: type.STRING(64),
            allowNull: false,
            defaultValue: 'queued',
        },
        id: {
          type: type.INTEGER,
          primaryKey: true,
          autoIncrement: true
        },
    };

    return schema;
}

